import {TranslationOptionInterface} from "../interfaces";

export const TranslationOptions: Array<TranslationOptionInterface> = [
  {
    option: "cs",
    label: "Tschechisch"
  },
  {
    option: "de",
    label: "Deutsch"
  },
  {
    option: "en",
    label: "Englisch"
  },
  {
    option: "es",
    label: "Spanisch"
  },
  {
    option: "fr",
    label: "Französisch"
  },
  {
    option: "hu",
    label: "Ungarisch"
  },
  {
    option: "it",
    label: "Italienisch"
  },
  {
    option: "ko",
    label: "Koreanisch"
  },
  {
    option: "nl",
    label: "Niederländisch"
  },
  {
    option: "pl",
    label: "Polnisch"
  },
  {
    option: "zh",
    label: "Chinesisch"
  }
];
